import settings from '../_settings.js';
import Size from './Size.js';

export default class Point {
    x = null;
    y = null;

    xPixel = null;
    yPixel = null;

    level = null;

    constructor(x = null, y = null, level = 0, xPixel = null, yPixel = null, isScaled = false) {
        if (x instanceof Point) {
            y = x.y;
            x = x.x;
        }
        this.level = level;
        this.xPixel = xPixel;
        this.yPixel = yPixel;
        this.setCords(x, y, isScaled);
    }

    setX(x, isScaled = false) {
        this.x = isScaled ? (x / settings.scalingFactor) : x;

        return this;
    }

    setY(y, isScaled = false) {
        this.y = isScaled ? (y / settings.scalingFactor) : y;

        return this;
    }

    setCords(x, y, isScaled = false) {
        this.setX(x, isScaled);
        this.setY(y, isScaled);

        return this;
    }

    get scaled() {
        return {
            x: this.x * settings.scalingFactor,
            y: this.y * settings.scalingFactor,
        };
    }

    moveBy(size) {
        if (size instanceof Point) {
            size = new Size(size.x, size.y);
        }
        if (!(size instanceof Size)) {
            throw new Error('size must be an instance of Size');
        }

        this.x += size.width;
        this.y += size.height;

        return this;
    }

    move(x, y) {
        if (x instanceof Point) {
            y = x.y;
            x = x.x;
        }
        return new Point(this.x + x, this.y + y, this.level);
    }

    toBounds(size) {
        if (!(size instanceof Size)) {
            throw new Error('size must be an instance of Size');
        }

        return size.toBounds(this);
    }

    getHash() {
        let n = 10000000;
        return this.level * (n + 1)^2 + this.x * (n + 1) + this.y;
        // return this.y * 1000000 + this.x;
        // return (0.5 * (this.x + this.y) * (this.x + this.y + 1)) + this.y;
        // return ( this.y << 16 ) ^ this.x
    }

    // Be aware: when called it mutates x and y
    isIntersection(tresh = 10) {
        let threshold = tresh;
        let scaledTreshold = settings.scalingFactor - threshold;

        let xOffset = this.xPixel % settings.scalingFactor;
        let yOffset = this.yPixel % settings.scalingFactor;

        // RB
        if ((xOffset <= threshold) && (yOffset <= threshold)) {
            return true;
        }
        // LT
        if ((xOffset >= scaledTreshold) && (yOffset >= scaledTreshold)) {
            // TODO fix this hack 
            this.x += 1;
            this.y += 1;
            return true;
        }
        // RT
        if ((xOffset <= threshold) && (yOffset >= scaledTreshold)) {
            // TODO fix this hack 
            this.y += 1;
            return true;    
        }
        // LB
        if ((xOffset >= scaledTreshold) && (yOffset <= threshold)) {
            // TODO fix this hack 
            this.x += 1;
            return true;
        }
        return false;
    }

    swap() {
        let tempX = this.x
        this.x = this.y;
        this.y = tempX;
    }

    toString() { 
        return "(" + this.x + "," + this.y + ") level " + this.level;
    }
}
